import * as yup from "yup";

export const createSupportSchema = () => {
    return yup.object().shape({
        subject: yup.string().max(200).required(),
        phone: yup.string().max(50).nullable(),
        email: yup.string().email({key: 'YUP.ERROR.KUNDE_EMAIL_FORMAT'}).max(100).required(),
        description: yup.string().max(1000).required(),
    })
}
